import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap'
import vSelect from 'vue-select'
import './assets/css/style.scss'

import Default from './layouts/Default.vue'
import NoNavbar from './layouts/NoNavbar.vue'

import {
  library
} from '@fortawesome/fontawesome-svg-core'

import {
  faThLarge,
  faCompass,
  faSignOutAlt,
  faMapMarkerAlt,
  faBolt,
  faCalendarAlt,
  faBars,
  faTimes,
  faList,
  faFilePdf,
  faDownload,
  faTools,
  faDatabase,
  faCaretRight,
  faCircle,
  faPlus,
  faPlusCircle,
  faPen,
  faTrashAlt,
  faChartArea,
  faPrint,
  faRulerVertical,
  faAngleUp,
  faAward,
  faQuestionCircle,
  faFileInvoice,
  faFilter,
  faThermometerQuarter,
  faClipboardList,
  faCheck,
  faAngleRight,
  faAngleLeft,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faCheckCircle,
  faCertificate,
  faColumns,
  faHammer,
  faMinusCircle,
  faWrench,
  faExclamation,
  faFileExcel
} from '@fortawesome/free-solid-svg-icons'
import {
  faTimesCircle,
  faSave,
  faCheckSquare,
  faEdit
} from '@fortawesome/free-regular-svg-icons'
import {} from '@fortawesome/free-brands-svg-icons'
import {
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'

library.add(faThLarge)
library.add(faPlusCircle)
library.add(faCompass)
library.add(faCertificate)
library.add(faSignOutAlt)
library.add(faMapMarkerAlt)
library.add(faBolt)
library.add(faCalendarAlt)
library.add(faBars)
library.add(faTimes)
library.add(faList)
library.add(faFilePdf)
library.add(faDownload)
library.add(faTools)
library.add(faDatabase)
library.add(faCaretRight)
library.add(faCircle)
library.add(faCheckCircle)
library.add(faPlus)
library.add(faTimesCircle)
library.add(faSave)
library.add(faPen)
library.add(faTrashAlt)
library.add(faChartArea)
library.add(faPrint)
library.add(faRulerVertical)
library.add(faAngleUp)
library.add(faCheckSquare)
library.add(faAward)
library.add(faQuestionCircle)
library.add(faFileInvoice)
library.add(faFilter)
library.add(faThermometerQuarter)
library.add(faClipboardList)
library.add(faCheck)
library.add(faAngleRight)
library.add(faAngleLeft)
library.add(faAngleDoubleRight)
library.add(faAngleDoubleLeft)
library.add(faColumns)
library.add(faHammer)
library.add(faMinusCircle)
library.add(faWrench)
library.add(faEdit)
library.add(faExclamation)
library.add([faFileExcel])

Vue.component('v-select', vSelect)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('default-layout', Default)
Vue.component('no-navbar-layout', NoNavbar)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')